import React from 'react';
import PropTypes from 'prop-types';

import MotifRadioButton from '@ey/motif-react-wrapper/RadioButton';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import OutputText from '@ey/canvascoreservices/OutputText';

import StyledRadioGroup from './StyledRadioGroup';

const RadioButtonGroup = ({name = '', options = null, value = null, onChange = null, variantHorizontal = false}) => {
	if (!options) return false;

	const renderItem = ({id, label, disabled = false}) => {
		const props = {
			id,
			checked: value === id,
			onChange: () => onChange && onChange(id),
			disabled
		};

		return (
			<MotifRadioButton {...props}>
				<OutputText useTypography={false} ellipsis title={label}>
					{label}
				</OutputText>
			</MotifRadioButton>
		);
	};

	const props = {
		name,
		$variantHorizontal: variantHorizontal
	};

	return (
		<MotifFormField>
			<StyledRadioGroup {...props}>{options.map(renderItem)}</StyledRadioGroup>
		</MotifFormField>
	);
};

RadioButtonGroup.propTypes = {
	name: PropTypes.string.isRequired,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.string.isRequired,
			label: PropTypes.string.isRequired,
			disabled: PropTypes.bool
		})
	),
	value: PropTypes.string,
	onChange: PropTypes.func,
	variantHorizontal: PropTypes.bool
};

export default RadioButtonGroup;
